import useClientContext from "../../context/useClientContext";
import CorporateAccountingProductIcon from "../common/domain-icons/CorporateAccountingProductIcon";
import { getBusinessCentralRedirectUrl } from "../../utilities/navigationHelper";
import OpenExternalLinkMenuItem from "../common/OpenExternalLinkMenuItem";

const CorpAccountingMenuLinkItem = () => {
  const { clientCode, settings } = useClientContext();

  if (!settings.businessCentralSettings) {
    return null;
  }

  const businessCentralUrl = getBusinessCentralRedirectUrl(
    clientCode,
    settings.businessCentralSettings,
    "EAC Corporate Accountant"
  );

  return (
    <OpenExternalLinkMenuItem
      Icon={CorporateAccountingProductIcon}
      title="Corporate Accounting"
      href={businessCentralUrl}
    />
  );
};

export default CorpAccountingMenuLinkItem;
